 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0,
 		6: 0,
 		8: 0,
 		9: 0,
 		70: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0,
 		6: 0,
 		8: 0,
 		9: 0,
 		70: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~23538779","2":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","3":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCo~837a17c8","4":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-habitats~route-highl~8cd8e8f4","5":"vendors~route-MapView~route-habitat~route-habitats~route-highlights~route-home~route-myAlbum~route-schedule","7":"vendors~route-MapView~route-habitats~route-myAlbum","11":"route-account~route-login","12":"route-adminUsers~route-schedule","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-passwordReset","45":"route-plans","46":"route-profile","47":"route-redeem","48":"route-reports","49":"route-schedule","50":"route-signup","51":"route-socialLogin","52":"route-softReload","53":"route-talkSchedule","54":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"c1921","1":"5a855","2":"228ee","3":"94c6d","4":"ef9ba","5":"d6521","6":"3b0e4","7":"749d4","8":"bbce2","9":"80ad6","10":"83904","11":"a551b","12":"959af","16":"da255","17":"19a5f","18":"efe98","19":"ccaae","20":"02d30","21":"503b8","22":"7626e","23":"8a96a","24":"89c5c","25":"b785b","26":"9d359","27":"3d778","28":"9a67a","29":"ac18a","30":"c91bb","31":"b96ba","32":"62305","33":"9f6fa","34":"846d1","35":"3d485","36":"5f061","37":"23de9","38":"b31b6","39":"8a03f","40":"1c22f","41":"f4ff2","42":"e0f77","43":"a7e60","44":"176a2","45":"97ebd","46":"7b159","47":"6f57a","48":"17641","49":"32e83","50":"c3adf","51":"802de","52":"f9fb2","53":"b507e","54":"15814","55":"d1ca8","56":"ab7fd","57":"7e8c6","58":"1c286","59":"598ba","60":"42fa7","61":"47e71","62":"6c781","63":"6e112","64":"52548","65":"790ca","66":"43b51","67":"77e26","68":"276de","69":"1a092","71":"61637","72":"fcdb6","73":"0e6cc","74":"cfaa6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"11":1,"12":1,"16":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"27":1,"29":1,"30":1,"31":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"53":1,"55":1,"56":1,"57":1,"58":1,"61":1,"62":1,"63":1,"64":1,"66":1,"68":1,"69":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~23538779","2":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","3":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCo~837a17c8","4":"vendors~route-MapView~route-adminCameraSettings~route-album~route-habitat~route-habitats~route-highl~8cd8e8f4","5":"vendors~route-MapView~route-habitat~route-habitats~route-highlights~route-home~route-myAlbum~route-schedule","7":"vendors~route-MapView~route-habitats~route-myAlbum","11":"route-account~route-login","12":"route-adminUsers~route-schedule","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-passwordReset","45":"route-plans","46":"route-profile","47":"route-redeem","48":"route-reports","49":"route-schedule","50":"route-signup","51":"route-socialLogin","52":"route-softReload","53":"route-talkSchedule","54":"route-welcome"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"31d6c","3":"08f1a","4":"31d6c","5":"31d6c","6":"31d6c","7":"31d6c","8":"31d6c","9":"31d6c","10":"31d6c","11":"88da0","12":"ca957","16":"9e9cf","17":"31d6c","18":"7a826","19":"197d1","20":"197d1","21":"197d1","22":"0af25","23":"197d1","24":"abe1c","25":"31d6c","26":"5acf9","27":"197d1","28":"31d6c","29":"f7a5c","30":"9c613","31":"7990d","32":"31d6c","33":"c8982","34":"6cb08","35":"eab88","36":"3a1a1","37":"68e7b","38":"4e8b6","39":"31d6c","40":"55fd1","41":"47ba8","42":"0e780","43":"31d6c","44":"5255f","45":"cfcea","46":"8c877","47":"a3247","48":"576ae","49":"5eb5c","50":"3a45d","51":"31d6c","52":"31d6c","53":"ba6f8","54":"31d6c","55":"1e8d3","56":"934b9","57":"05a6c","58":"9abce","59":"31d6c","60":"31d6c","61":"91d99","62":"91d99","63":"c75d8","64":"65381","65":"31d6c","66":"91d99","67":"31d6c","68":"3c18c","69":"39184","71":"31d6c","72":"31d6c","73":"31d6c","74":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
